namespace GeniuzPOS.Inventory {
    export interface IcStockApproveSetAssembleDtForm {
        SysDocNo: Serenity.StringEditor;
        LineItemNo: Serenity.IntegerEditor;
        PluCode: Serenity.StringEditor;
        PluDesc: Serenity.StringEditor;
        SetItemQty: Serenity.DecimalEditor;
        Qty: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
    }

    export class IcStockApproveSetAssembleDtForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockApproveSetAssembleDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockApproveSetAssembleDtForm.init)  {
                IcStockApproveSetAssembleDtForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(IcStockApproveSetAssembleDtForm, [
                    'SysDocNo', w0,
                    'LineItemNo', w1,
                    'PluCode', w0,
                    'PluDesc', w0,
                    'SetItemQty', w2,
                    'Qty', w2,
                    'Remark', w0
                ]);
            }
        }
    }
}
